import PropTypes from 'prop-types';
import React from 'react';

// material-ui
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, Box, ButtonBase } from '@material-ui/core';

// project imports
import LogoSection from '../LogoSection';
import SearchSection from './SearchSection';
import LocalizationSection from './LocalizationSection';
import MobileSection from './MobileSection';
import ProfileSection from './ProfileSection';
import NotificationSection from './NotificationSection';

// assets
import { IconMenu2 } from '@tabler/icons';
import DialerHeader from '../../../menu-items/Dashboard/AutoDailer/DialerInitialState';
import DialerTimer from '../../../menu-items/Dashboard/AutoDailer/DialerTimer';
import DialerMode from '../../../menu-items/Dashboard/AutoDailer/DialerMode';
import DialerInitialState from '../../../menu-items/Dashboard/AutoDailer/DialerInitialState';
import DialerBreakState from '../../../menu-items/Dashboard/AutoDailer/DialerBreakState';
import TicketInfo from '../../../menu-items/Dashboard/AutoDailer/TicketInfo';
import { getDecryptDataFromLocal } from '../../../utils/encrypt';

// style constant
const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
        textAlign: 'center'
    },
    headerAvatar: {
        ...theme.typography.commonAvatar,
        ...theme.typography.mediumAvatar,
        transition: 'all .2s ease-in-out',
        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.secondary.light,
        color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
        '&:hover': {
            background: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
            color: theme.palette.mode === 'dark' ? theme.palette.secondary.light : theme.palette.secondary.light
        }
    },
    boxContainer: {
        width: '228px',
        display: 'flex',
        [theme.breakpoints.down('md')]: {
            width: 'auto'
        }
    }
}));

//-----------------------|| MAIN NAVBAR / HEADER ||-----------------------//

const Header = ({ handleLeftDrawerToggle }) => {
    const classes = useStyles();

    let role = getDecryptDataFromLocal('setRole')


    return (
        <React.Fragment>
            {/* logo & toggler button */}
            <div className={classes.boxContainer}>
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>
                <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                    <Avatar variant="rounded" className={classes.headerAvatar} onClick={handleLeftDrawerToggle} color="inherit">
                        <IconMenu2 stroke={1.5} size="1.3rem" />
                    </Avatar>
                </ButtonBase>
            </div>

            {/* header search */}
            {/* <SearchSection theme="light" /> */}
            {
                role == '5' ?
                    <>
                        <div className={classes.grow}>
                            {/* <DialerInitialState /> */}
                        </div>
                        <div className={classes.grow}>
                            {/* <DialerMode /> */}
                        </div>
                        <div className={classes.grow}>
                            {/* <DialerBreakState /> */}
                        </div>

                        <div className={classes.grow}>
                            {/* <TicketInfo /> */}
                        </div>
                    </>
                    :
                    <>
                        <div className={classes.grow}>

                        </div>
                        <div className={classes.grow}>

                        </div>
                        <div className={classes.grow}>

                        </div>


                    </>
            }


            {/* live customization & localization */}
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                <LocalizationSection />
            </Box>

            {/* notification & profile */}
            <NotificationSection />
            <ProfileSection />

            {/* mobile header */}
            <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                <MobileSection />
            </Box>
        </React.Fragment>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
